import { collection, getDocs, getFirestore, query } from 'firebase/firestore';
import { salaryDeductionConverter } from '../converters/salaryDeductionConverter';

export const querySalaryDeduction = async (idNUmber: string) => {
  const db = getFirestore();
  const colRef = collection(db, `Employees/${idNUmber}/SalaryDeductions`).withConverter(salaryDeductionConverter);
  return (await getDocs(query(colRef))).docs.map(snap => snap.data());
};
